import styled from "@emotion/styled";

export const SearchResultExtraRowContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing["2"]};
`;
